import React from "react";
import {
	List,
	Button,
  Avatar,
  Tag,
  Typography
} from "antd";
import { Link } from 'react-router';

const { Paragraph } = Typography;

const ListItem = ({ item, width, redirectLink, buttonTitle } ) => {

  let listItem = (
    <List.Item className="list-item" key={item.id}>
      <div className="list-item-avatar">
        <Avatar src={item.PhotoUrl || item.thumbnail} size={40} />
      </div>
      <div className="list-item-content">
        <Paragraph  className="list-item-name" ellipsis>{item.DisplayName || item.title}</Paragraph>
        <Tag className={`tag-${item.type}`}>{item.type}</Tag>
      </div>
      <div className="list-item-button">
        <Link to={redirectLink}>
          <Button type="primary" ghost>
            View {<span>{buttonTitle}</span>}
          </Button>
        </Link>
      </div>
    </List.Item>
  );
  if (width && width < 578) {
    listItem = (
      <List.Item className="list-item" key={item.id}>
        <Link to={redirectLink}>
          <div className="list-item-avatar">
            <Avatar src={item.PhotoUrl || item.thumbnail} size={40} />
          </div>
          <div className="list-item-content">
            <Paragraph  className="list-item-name" ellipsis>{item.DisplayName || item.title}</Paragraph>
            <Tag className={`tag-${item.type}`}>{item.type}</Tag>
          </div>
        </Link>
      </List.Item>
    );
  }

  return listItem;
};

export default ListItem;


// WEBPACK FOOTER //
// ./src/components/ListItem.js